import React, { useState } from 'react';

function DateInput({setSelectedDate, selectedDate}) {
  // const [selectedDate, setSelectedDate] = useState('');

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  return (
    <div>
      <label htmlFor="date">Date of incorporation</label>
      <input
      className='w-100 border-1 border border-rounded p-2'
        type="date"
        id="date"
        name="date"
        value={selectedDate}
        onChange={handleDateChange}
      />
      {/* <p>Selected Date: {selectedDate}</p> */}
    </div>
  );
}

export default DateInput;
